const drawer = {
  open: false,
};

export default drawer;



// WEBPACK FOOTER //
// ./app/data/drawer.js